import { createEntity } from '../form-designer/actions/form-manager.actions';

export function displayStepForm({
  entityViewName,
  entityType,
  containerWorkflowKey,
  workflowKey,
  stepId,
  itmId,
  formKey,
  entityName,
  storeKey,
  workflowId = '',
}) {
  return (dispatch) => {
    dispatch(
      createEntity({
        entityViewName,
        entityType,
        orgId: '',
        formKey,
        containerWorkflowKey,
        workflowKey,
        workflowId,
        stepId,
        storeKey,
        itmId,
        entityName,
      })
    );
  };
}
